import React from "react";

import { InjectIntlContext } from "@comparaonline/react-intl-hooks";
import { AppProps, default as NextApp, DefaultAppIProps, NextAppContext } from "next/app";
import { addLocaleData, IntlProvider } from "react-intl";

// Register React Intl's locale data for the user's locale in the browser. This
// locale data was added to the page by `pages/_document.js`. This only happens
// once, on initial page load in the browser.
if (typeof window !== "undefined" && window.ReactIntlLocaleData) {
  Object.keys(window.ReactIntlLocaleData).forEach((lang: string) => {
    addLocaleData(window.ReactIntlLocaleData[lang]);
  });
  window.ReactIntlLocaleData = {};
}

interface IProps extends DefaultAppIProps, AppProps, IntlProvider.Props {}

export const withIntlProvider = (App: typeof NextApp) => {
  return class WithIntlProvider extends React.Component<IProps> {
    public static async getInitialProps(appContext: NextAppContext) {
      const appProps = App.getInitialProps
        ? await App.getInitialProps(appContext)
        : { pageProps: {} };

      const { locale, messages } = appContext.ctx.req || window.__NEXT_DATA__.props;
      const initialNow = Date.now();

      return { ...appProps, locale, messages, initialNow };
    }

    public render() {
      const { locale, messages, initialNow } = this.props;
      return (
        <IntlProvider locale={locale} messages={messages} initialNow={initialNow}>
          <InjectIntlContext>
            <App {...this.props} />
          </InjectIntlContext>
        </IntlProvider>
      );
    }
  };
};
